"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagickRecord = void 0;
const unicrypto_1 = require("unicrypto");
const MapSerializer_1 = require("./MapSerializer");
class MagickRecord {
    static async pack(record) {
        const bw = new unicrypto_1.Boss.Writer();
        bw.write(record.label);
        bw.write(await MapSerializer_1.MapSerializer.serializeAny(record.payload));
        return bw.get();
    }
    /**
     * Unpack magick framed record optionally checking the label.
     * @param packed
     * @param labels if at least one label presents, will not unpack the rest of the record unless the loaded label is
     *        listed among labels.
     * @throws MagickRecord.Exception if the label is not present in an non-empty labels.
     */
    static async unpack(packed, ...labels) {
        const br = new unicrypto_1.Boss.Reader(packed);
        const label = br.read();
        if (labels.length && !labels.includes(label))
            throw new MagickRecord.Exception(`label ${label} does not belong to allowed: ${labels}`);
        return { label, payload: await MapSerializer_1.MapSerializer.deserializeAny(br.read()) };
    }
}
exports.MagickRecord = MagickRecord;
MagickRecord.Exception = class extends Error {
};
//# sourceMappingURL=MagickRecord.js.map